import React, { Component } from 'react';
import Moment from 'react-moment';
import CommonConstants from '../../constants/CommonConstants';

import './Properties.css';

class Properties extends Component {
  static DATE_TYPE = 'DATE_TYPE';

  _convertToHumanReadable(propertyName) {
    let words = propertyName.match(/[A-Za-z][a-z]*/g) || [];
    return words.map(this._capitalize).join(" ");
  }

  _capitalize(word) {
      return word.charAt(0).toUpperCase() + word.substring(1);
  }

  _buildValueElement(value, type) {
    switch (type) {
      case Properties.DATE_TYPE:
        return <Moment format={ CommonConstants.NUXEO_DATE_FORMAT }>{ value }</Moment>
      default:
        return value && typeof value === 'string' ? value.split(";").map((key, id) => <h2 className="property-value" key={id}>{ key }</h2>) : value
    }
  }

  render() {
    const { object, properties } = this.props;
    
    return (
      <div className="properties">
        {
          properties
            .filter((property) => {
              let propertyArray = property.name.split('.');
              return object[propertyArray[0]];
            })
            .map((property, id) => {
              let propertyValue = '';
              if(property.name.indexOf('.') !== -1){
                let propertyArray = property.name.split('.');
                propertyValue = object[propertyArray[0]][propertyArray[1]];
              }
              else{
                propertyValue = object[property.name];
              }
              return (
                <div key={ id }>
                  <h2 className="property-name">{ property.displayName ? property.displayName : property.name }</h2>
                  { this._buildValueElement(propertyValue, property.type) }
                </div>
                )  
            })
        }
      </div>
    );
  }
}

export default Properties;
